import { useMemo } from 'react';

import { useGetTenantsQuery } from '@features/tenants';
import { Alert, Box } from '@mui/material';
import { Navigate } from 'react-router';

import { InlineLoader } from '@/components/common';

/**
 * Index route for /account-settings.
 *
 * Themes was the previous default landing page but has since been hidden from
 * the sidebar. Redirect users to the first organization's Users page instead.
 */
export const AccountSettingsIndex = () => {
  const { data: tenants, isLoading, error } = useGetTenantsQuery();

  const firstTenantId = useMemo(() => {
    if (!tenants || tenants.length === 0) return null;
    const sorted = [...tenants].sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    return sorted[0]?.tenantId ?? null;
  }, [tenants]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
        <InlineLoader size={32} />
      </Box>
    );
  }

  if (error || !firstTenantId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info">No organizations available.</Alert>
      </Box>
    );
  }

  return <Navigate to={`organizations/${firstTenantId}/users`} replace />;
};
